function initReadMoreContainers() {
  document.querySelectorAll('.wim-read-more__container').forEach(container => {
    const content = container.querySelector('.wim-read-more__content');
    const button = container.querySelector('.wim-read-more__btn');

    if (!content || !button) return;

    const spanReadMore = button.querySelector('.wim-read-more__text');
    const spanReadLess = button.querySelector('.wim-read-less__text');

    if (!spanReadMore || !spanReadLess) return;

    const maxVisibleLines = parseInt(content.dataset.chunkLines, 10) || 10;

    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);

    const maxHeight = maxVisibleLines * lineHeight;

    const contentHeight = content.scrollHeight;

    let visibleMarginBottom = 0;
    let accumulatedHeight = 0;

    content.childNodes.forEach(child => {
      if (child.nodeType === 1) {
        const childHeight = child.offsetHeight;
        const childMarginBottom = parseFloat(getComputedStyle(child).marginBottom) || 0;

        accumulatedHeight += childHeight;

        if (accumulatedHeight <= maxHeight) {
          visibleMarginBottom += childMarginBottom;
        }
      }
    });

    const adjustedMaxHeight = maxHeight + visibleMarginBottom;

    const totalLines = Math.ceil(contentHeight / lineHeight);

    if (totalLines > maxVisibleLines) {
      button.style.display = 'inline-block';

      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        let get_scroll_position = window.scrollY;
        if (isExpanded) {
          content.style.maxHeight = `${contentHeight}px`;
          spanReadMore.style.display = 'none';
          spanReadLess.style.display = 'inline';
          content.setAttribute('aria-expanded', 'true');
        } else {
          content.style.maxHeight = `${adjustedMaxHeight}px`;
          spanReadMore.style.display = 'inline';
          spanReadLess.style.display = 'none';
          content.setAttribute('aria-expanded', 'false');
          window.scrollTo({ top: get_scroll_position, behavior: 'smooth' });
        }
      });

      content.style.maxHeight = `${adjustedMaxHeight}px`;
    } else {
      button.style.display = 'none';
      content.setAttribute('aria-expanded', 'true');
    }
  });
};
document.addEventListener("DOMContentLoaded", function () {
  const shopifyClient = new ShopifyStorefrontClient();
  initReadMoreContainers();
  const slider = document.querySelector('.wim-collection-desktop-slider .grid--slider');

  if (slider) {

    let isDragging = false;
    let initialX;
    let initialValue;

    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      initialX = e.clientX;
      initialValue = 0;
      slider.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - initialX;
      const newValue = initialValue + deltaX;
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        slider.style.cursor = 'grab';
      }
    });
  }

  handleMouseOverMenuHeader(document.querySelectorAll('.wim-main-link'), document.querySelectorAll(`.wim-header__sub-menu .wim-header__sub-menu-type`));
  handleMouseOverMenuHeader(document.querySelectorAll('.wim-sub-link'), document.querySelectorAll(`.wim-header__extra-links-lvl-1 .wim-dropdown__extra-links`));
  handleMouseOverMenuHeader(document.querySelectorAll('.wim-extra-link'), document.querySelectorAll(`.wim-header__extra-links-lvl-2 .wim-dropdown__extra-links`));

  sortMenu('desktop', '.wim-header__full-sub-menu', '.wim-header__sub-links');
  sortMenu('desktop', '.wim-header__divide-sub-menu', '.wim-header__divide-sub-menu-links');
  sortMenu('desktop', '.header__dropdown__inner', '.header__simple-dropdown');

  sortMenu('mobile', '.mobile__menu__dropdown', '.sliderow__links');

  let nav_header_item = document.querySelectorAll('.wim-header .menu__item.grandparent > a.navlink--toplevel');

  if (nav_header_item.length > 0) {
    nav_header_item.forEach((item) => {
      item.addEventListener('mouseover', (event) => {
        nav_header_item.forEach((nav_item) => {
          nav_item.classList.remove('selected-item');
        });
        item.classList.add('selected-item');
      });
    });
  }
  let collection_subcategories = document.querySelector('.wim-collection-subcategories__list');
  if (collection_subcategories) {
    let subcategory_items = Array.from(collection_subcategories.children);
    subcategory_items.sort((a, b) => {
      let textA = a.querySelector('a').textContent.trim().toUpperCase();
      let textB = b.querySelector('a').textContent.trim().toUpperCase();
      return textA.localeCompare(textB);
    });
    collection_subcategories.innerHTML = '';
    subcategory_items.forEach((item) => {
      collection_subcategories.appendChild(item);
    });
  }
  activeCustomer(shopifyClient);
  setTimeout(() => {
    let wishlist_buttons = document.querySelectorAll('.wishlist-hero-custom-button button');
    let icon_heart_empty = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" overflow="unset" class="icon">
      <path d="M12.4869 22C12.2364 21.9968 11.9918 21.9232 11.7804 21.7875C8.18822 19.57 5.48518 17.3766 3.2783 14.8705C2.01853 13.5287 1.04215 11.942 0.408559 10.207C-0.730606 6.84675 0.5832 2.9211 3.46882 1.07256C4.78425 0.221399 6.35422 -0.134962 7.90363 0.0659208C9.45304 0.266804 10.8831 1.01212 11.9431 2.17126C12.1376 2.37977 12.3162 2.60031 12.4869 2.81685C12.7194 2.51694 12.97 2.2317 13.2371 1.96275C13.8816 1.32075 14.6473 0.816306 15.4888 0.479444C16.3303 0.142583 17.2302 -0.0198119 18.1351 0.00192686C19.0214 0.0266866 19.8936 0.23235 20.6992 0.606539C21.5048 0.980728 22.2271 1.51571 22.8227 2.17928C25.0693 4.63732 25.6012 7.62065 24.3072 10.8045C23.6255 12.404 22.6611 13.8647 21.4613 15.1151C19.3548 17.3836 16.9713 19.3724 14.3683 21.0336C14.019 21.2662 13.6578 21.4907 13.3006 21.7113L13.1934 21.7795C12.9825 21.9174 12.738 21.9937 12.4869 22Z" stroke="currentColor"></path>
    </svg>`;
    wishlist_buttons.forEach((button) => {
      button.innerHTML = icon_heart_empty;
    });
    let wishlist_product_button = document.querySelector('.wishlisthero-product-page-button-container button');
    if (wishlist_product_button) {
      wishlist_product_button.innerHTML = icon_heart_empty;
    }
    let wishlist_delete_buttons = document.querySelectorAll('.wishlist-hero-list-card-footer-delete > span.MuiIconButton-label');
    wishlist_delete_buttons.forEach((icon) => {
      icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none" class="icon-delete">
        <mask id="mask0_119_751" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
          <rect width="32" height="32" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_119_751)">
          <path d="M8.53281 24.8667L7.13281 23.4667L14.5995 16L7.13281 8.53336L8.53281 7.13336L15.9995 14.6L23.4661 7.13336L24.8661 8.53336L17.3995 16L24.8661 23.4667L23.4661 24.8667L15.9995 17.4L8.53281 24.8667Z" fill="#231E20"/>
        </g>
      </svg>`;
    });
    let wishlist_header_page = document.querySelector('.wishlist-hero-page-header');
    if (wishlist_header_page) {
      wishlist_header_page.innerHTML = `${icon_heart_empty}${wishlist_header_page.innerHTML.split('</svg>')[1]}`;
    }
  }, 2000);
  let cart_error_close = document.querySelectorAll('.cart__errors__close');
  cart_error_close.forEach((close) => {
    close.addEventListener('click', () => {
      close.closest('.cart__errors').classList.remove('is-expanded');
    });
  });
});
function activeCustomer(shopifyClient) {

  if (document.querySelector('.container-form--active-customer-app-block')) {

    /*
      Form Shopify App: la ejecucion de estos formularios es un poco compleja debido a que no es la etiqueta form
      la que envia los datos, sino que se utiliza fetch para enviar los datos a una url especifica
      Esta url: https://forms.shopifyapps.com/api/v2/form_submission

      Es la que realmente envia los datos del formulario de la app por lo tanto se creo una funcion que 
      intercepta los fetch de la pagina para poder ejecutar la consulta GraphQL en el momento indicado

      la idea es que cuando se envie el fetch de la url indicada, se ejecute la funcion customerRecover
      del cliente de Shopify Storefront API para que envie el email de recuperacion de contraseña si fuese el caso

      ya el formulario de la app se encarga de enviar el email de activacion de cuenta si fuese el caso, 
      esto por medio de un flujo en la app Shopify Flow

      Importante: no solo la url es importante, tambien el metodo debe ser POST y el body debe ser un string JSON,
      debido a que existe otra consulta que se hace con la misma url y el body es un FormData, que no permite obtener
      el email

      Para mas informacion sobre la consulta GraphQL customerRecover ver el archivo wim-storefront.js
    */
    const originalFetch = window.fetch;
    window.fetch = function (...args) {

      return originalFetch.apply(this, args).then((response) => {
        const [url, options] = args;
        if (
          url === 'https://forms.shopifyapps.com/api/v2/form_submission' &&
          options.method === 'POST' &&
          typeof options.body === 'string'
        ) {
          try {
            let body_json = JSON.parse(options.body);
            if (body_json && body_json?.email) {

              shopifyClient
                .customerRecover(body_json.email)
                .then((res) => console.log('Recovery email sent:', res));
            }
          } catch (error) {
            console.error('Error occurred while sending recovery email:', error);
          }
        }
        return response;
      });
    };
  }
}
function handleMouseOverMenuHeader(links, sub_menus) {
  if (links.length > 0) {
    links.forEach((link) => {
      link.addEventListener('mouseover', (event) => {
        links.forEach((nav_item) => {
          nav_item.classList.remove('selected-item');
        });
        link.classList.add('selected-item');
        if (sub_menus) {
          sub_menus.forEach((sub_menu) => {
            if (sub_menu.dataset.target === link.dataset.target) {
              sub_menu.classList.remove('d-none');
            }
            else {
              sub_menu.classList.add('d-none');
              sub_menu.querySelectorAll('.selected-item').forEach((item) => {
                item.classList.remove('selected-item');
              });
            }
          });
        }

      });
    });
  }
};
function sortMenu(type_menu, class_sub_menu, class_sub_links) {

  let main_sub_menus = document.querySelectorAll(class_sub_menu);
  if (main_sub_menus.length > 0) {
    main_sub_menus.forEach((menu) => {
      let sub_menus = menu.querySelectorAll(class_sub_links);
      if (sub_menus.length > 0) {
        sub_menus.forEach((sub_menu) => {
          let sub_links = sub_menu.children;
          let sort_sub_links = [];
          let class_text = type_menu === 'desktop' ? 'a > span' : '.sliderule__wrapper div.sliderow > .sliderow__title > span';

          if (sub_links.length > 0 && sub_links[0]?.querySelector(class_text)) {
            sort_sub_links = Array.from(sub_links).map(item => {
              return { text: item.querySelector(class_text).innerHTML.trim(), element: item };
            }).sort((a, b) => a.text.localeCompare(b.text));
          }
          sub_menu.innerHTML = '';
          for (const item of sort_sub_links) {
            sub_menu.appendChild(item.element);
          }
        });
      }
    });
  }
};
(function injectShopifyFormEmbed() {
  const TARGET_SELECTOR = 'shopify-forms-embed';
  
  function contactFormEmbed(el, formId) {
    const isContactEmbed = Boolean(
      el.closest(`[data-forms-id="forms-root-${ formId }"]`) ||
      el.getAttribute('data-forms-id') === `forms-root-${ formId }`
    );
    if (!isContactEmbed) return;
    const sr = el.shadowRoot;
    if (!sr) return;
    if (sr.querySelector('div#app-embed[data-wim-inject]')) return;
    sr.querySelector('div#app-embed')?.setAttribute('data-wim-inject', 'true');
    let policyText = sr.querySelector('[name="custom#provacidad"] span');
    if( policyText && policyText.innerHTML.split("→").length > 1 ){
      policyText.innerHTML = `${ policyText.innerHTML.split("→")[0].trim() } → ${ `<a href="/policies/privacy-policy" target="_blank" title="${ policyText.innerHTML.split("→")[1].trim() }">${ policyText.innerHTML.split("→")[1].trim() }</a>` }`;
    }
  }
  function tryInject(el) {
    try {
      if (!el) return;
      contactFormEmbed(el, '559940');
      contactFormEmbed(el, '573737');
    } catch (e) {
      console.error('[wim] error injecting styles into shadowRoot', e);
    }
  }
  
  document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
  
  // Observe DOM for new embeds
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) tryInject(node);
        const descendants = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        descendants.forEach(tryInject);
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  
  // Retry pass for late-initialized shadowRoots (safety)
  let retries = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
    retries++;
    if (retries >= maxRetries) clearInterval(retryInterval);
  }, 500);
})();